export default __webpack_public_path__ + "images/avatar_coucou_no_text.88256ffd.png";